export const common = {
  // Navigation
  "nav.home": "Home",
  "nav.categories": "Categories", 
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.help": "Help",
  "nav.faq": "FAQ",
  "nav.privacy": "Privacy",
  "nav.terms": "Terms",
  "nav.login": "Login",
  "nav.register": "Register",
  "nav.dashboard": "Dashboard",
  "nav.profile": "Profile",
  "nav.logout": "Logout",
  "nav.search": "Search",
  "nav.suppliers": "Suppliers",
  "nav.products": "Products",
  "nav.admin": "Admin Panel",

  // Common buttons
  "btn.search": "Search",
  "btn.filter": "Filter",
  "btn.reset": "Reset",
  "btn.submit": "Submit",
  "btn.cancel": "Cancel",
  "btn.save": "Save",
  "btn.edit": "Edit",
  "btn.delete": "Delete",
  "btn.view": "View",
  "btn.contact": "Contact",
  "btn.call": "Call",
  "btn.email": "Email",
  "btn.website": "Website",
  "btn.directions": "Get Directions",
  "btn.back": "Back",
  "btn.next": "Next",
  "btn.previous": "Previous",
  "btn.close": "Close",
  "btn.open": "Open",
  "btn.show_more": "Show More",
  "btn.show_less": "Show Less",
  "btn.yes": "Yes",
  "btn.no": "No",

  // Common labels
  "label.name": "Name",
  "label.email": "Email",
  "label.phone": "Phone",
  "label.address": "Address",
  "label.city": "City",
  "label.state": "State",
  "label.country": "Country",
  "label.description": "Description",
  "label.category": "Category",
  "label.rating": "Rating",
  "label.reviews": "Reviews",
  "label.distance": "Distance",
  "label.location": "Location",
  "label.price": "Price",
  "label.date": "Date",
  "label.time": "Time",
  "label.status": "Status",
  "label.type": "Type",
  "label.language": "Language",

  "nav.purchase_request": "Purchase Request",
  "nav.navigation": "Navigation",
  "nav.more": "More",
  "nav.account": "Account",
  "common.clear_input": "Clear input",
  "common.return_home": "Return to home",
  "common.ok": "OK",
  "common.error": "Error",

  // Language selector accessibility
  "common.select_language": "Select language",
  "common.available_languages": "Available languages",
  "common.current_language": "Current language",

  // Status
  "status.active": "Active",
  "status.inactive": "Inactive",
  "status.pending": "Pending",
  "status.approved": "Approved",
  "status.rejected": "Rejected",
  "status.verified": "Verified",
  "status.unverified": "Unverified",

  // Messages
  "msg.loading": "Loading...",
  "msg.no_results": "No results found",
  "msg.error": "An error occurred",
  "msg.success": "Success",
  "msg.saved": "Saved successfully",
  "msg.deleted": "Deleted successfully",
  "msg.updated": "Updated successfully",
  "msg.created": "Created successfully",
  "msg.no_description": "No description available",

  // Distance units
  "distance.km": "km",
  "distance.miles": "miles",
  "distance.nearby": "Nearby",
  "distance.within": "Within",

  // Time
  "time.now": "Now",
  "time.today": "Today",
  "time.yesterday": "Yesterday",
  "time.week": "This week",
  "time.month": "This month",
  "time.year": "This year",

  // Currency
  "currency.symbol": "₦",
  "currency.code": "NGN",
  "currency.name": "Nigerian Naira",

  // Footer
  "footer.rights": "All rights reserved",
  "footer.powered_by": "Powered by Readdy",
  "footer.quick_links": "Quick Links",
  "footer.support": "Support",
  "footer.follow_us": "Follow us",
  "footer.description": "The leading geo-located search engine for all suppliers in Nigeria.",
  "footer.contact": "Contact",
  "footer.about": "About",

  // Pages
  "page.about": "About",
  "page.contact": "Contact",
  "page.faq": "FAQ",
  "page.help": "Help",
  "page.privacy": "Privacy",
  "page.categories": "Categories",
  "page.supplier": "Supplier",
  "page.admin": "Admin",

  // Location picker
  "location.country": "Country",
  "location.state_department": "State/Department",
  "location.city": "City",
  "location.address": "Address",
  "location.exact_location": "Exact Location",
  "location.select_country": "Select a country",
  "location.select_state": "Select a state/department",
  "location.city_placeholder": "Enter city name",
  "location.address_placeholder": "Enter street address",
  "location.select_country_state_first": "Please select a country and state first",
  "location.select_on_map": "Select location on map",
  "location.location_selected": "Location selected",
  "location.select_exact_location": "Select exact location",
  "location.selected_coordinates": "Selected coordinates",
  "location.map_instructions": "Click on the map to set your exact location, or enter coordinates manually below.",
  "location.manual_coords": "Manual coordinates (optional)",
  "location.latitude": "Latitude",
  "location.longitude": "Longitude",
  "location.confirm_location": "Confirm location",
  "location.coords": "Coordinates: {{lat}}, {{lng}}",

  // Map view
  "map.suppliers_found": "{{count}} suppliers found",
  "map.more_suppliers": "more suppliers",
  "map.exact_location": "Exact location",
  "map.approximate_location": "Approximate location",
  "map.approximate": "approximate",
  "map.expand": "Expand map",
  "map.full_map_view": "Full Map View",
  "map.suppliers": "suppliers",

  // DeepL Translation
  "translation.view_original": "View original",
  "translation.view_translation": "View translation",
  "translation.translated_by": "Translated by DeepL",
  "translation.translated_from": "Translated from",
  "translation.loading": "Translating...",
  
  // Read more / Show less
  "common.read_more": "Read more",
  "common.show_less": "Show less",
  "common.translated_from_english": "Translated from English",
  
  // Search translation (Alibaba-style)
  "search.translating": "Translating...",
  "search.translated_from": "Translated from",

  // Bug report
  "bug_report.title": "Report a Bug",
  "bug_report.description": "Help us improve the application",
  "bug_report.label": "Describe the problem encountered",
  "bug_report.placeholder": "Ex: The search button doesn't work on the page...",
  "bug_report.note": "This will open your email client with the pre-filled report.",
  "bug_report.sending": "Sending...",
  "bug_report.send": "Send Report",
  "bug_report.success_title": "Thank you!",
  "bug_report.success_message": "Your report has been sent. We will review it quickly.",
  "bug_report.button": "Report bug",

  // Quantity units
  "units.pieces": "Pieces",
  "units.kg": "Kilograms",
  "units.tonnes": "Tonnes",
  "units.litres": "Litres",
  "units.meters": "Meters",
  "units.units": "Units",
  "units.boxes": "Boxes",
  "units.pallets": "Pallets",
  "units.containers": "Containers",

  // Purchase request form
  "purchase_request.title": "Post a purchase request",
  "purchase_request.subtitle": "Quickly receive offers from qualified suppliers.",
  "purchase_request.form_header": "Fill in the form below and get offers from the best suppliers",
  "purchase_request.description": "Describe your need",
  "purchase_request.description_placeholder": "E.g.: Pure water machine",
  "purchase_request.attachment": "Product video, image or document (optional)",
  "purchase_request.attachment_desc": "Attach a descriptive video of the product (MP4, WebM, MOV), an image (JPG, PNG) or a document (PDF, Word)",
  "purchase_request.quantity": "Quantity",
  "purchase_request.whatsapp": "WhatsApp number",
  "purchase_request.whatsapp_placeholder": "+225 071486XXXX",
  "purchase_request.submit": "Send my request",
  "purchase_request.publishing": "Sending...",
  "purchase_request.footer": "Suppliers will contact you quickly",
  "purchase_request.errors.description_required": "Description is required",
  "purchase_request.errors.quantity_invalid": "Quantity must be greater than 0",
  "purchase_request.errors.whatsapp_required": "WhatsApp number is required",
  "purchase_request.errors.submission": "An error occurred. Please try again.",
  "purchase_request.success_title": "Request posted successfully!",
  "purchase_request.success_message": "Your request has been sent to our qualified suppliers. You will quickly receive suitable proposals.",
  "purchase_request.next_steps": "Next steps:",
  "purchase_request.step1": "Suppliers will review your request",
  "purchase_request.step2": "You will receive offers by email",
  "purchase_request.step3": "Compare and choose the best offer",
  "purchase_request.processing_option": "Processing option",
  "purchase_request.processing_normal": "Normal",
  "purchase_request.processing_normal_desc": "Processed within 1 to 2 weeks — Free",
  "purchase_request.processing_xpress": "Xpress",
  "purchase_request.processing_xpress_desc": "Priority processing within 48-72h — 15,000 FCFA",
  "purchase_request.processing_xpress_price": "15,000 FCFA",
  "purchase_request.processing_xpress_soon": "Coming soon",
  "purchase_request.email_label": "Email address (Xpress payment)",
  "purchase_request.email_placeholder": "you@example.com",
  "purchase_request.errors.email_required": "Email address is required for the Xpress payment",
  "purchase_request.errors.email_invalid": "Invalid email address",
  "purchase_request.errors.xpress_init_failed": "Could not initialize the Xpress payment. Your form data is kept — please try again.",
  "purchase_request.xpress_pending_note": "Your request is published in Normal mode. Activate Xpress for priority processing within 48-72h.",
  "purchase_request.xpress_unavailable_note": "Xpress payment is temporarily unavailable. Your request remains published in Normal mode (1 to 2 weeks).",
  "purchase_request.activate_xpress": "Activate Xpress now — 15,000 FCFA",
  "purchase_request.success_normal": "Your request will be processed within 1 to 2 weeks.",
  "purchase_request.request_number": "Your request number",
  "purchase_request.request_number_hint": "Keep this number to track your request from your dashboard.",
  "purchase_request.success_xpress": "Your Xpress request will be processed as a priority within 48-72h.",

  // Notifications (page /notifications, dropdown links)
  "notifications.page_title": "Notifications",
  "notifications.page_subtitle": "All your notifications, most recent first.",
  "notifications.mark_all_read": "Mark all as read",
  "notifications.load_more": "Load more",
  "notifications.empty_title": "No notifications",
  "notifications.empty_message": "Your notifications will appear here: new messages, quotes, updates on your requests.",
  "notifications.back_dashboard": "Back to dashboard",
  "notifications.view_details": "View details",
  "notifications.unread_count": "{{count}} unread",
  "notifications.just_now": "Just now",
  "notifications.minutes_ago": "{{count}} min ago",
  "notifications.hours_ago": "{{count}}h ago",
  "notifications.yesterday": "Yesterday",
  "notifications.days_ago": "{{count}} days ago",
  "notifications.title": "Notifications",
  "notifications.none_unread": "No unread notifications",
  "notifications.view_all": "View all notifications",
  "notifications.dropdown_empty": "You don't have any notifications yet",

  // Newsletter unsubscribe (page /newsletter/unsubscribe)
  "newsletter_unsubscribe.title": "Newsletter unsubscribe",
  "newsletter_unsubscribe.description": "Confirm your unsubscription: you will no longer receive Suji emails.",
  "newsletter_unsubscribe.email_label": "Your email address",
  "newsletter_unsubscribe.submit": "Unsubscribe",
  "newsletter_unsubscribe.processing_title": "Unsubscribing...",
  "newsletter_unsubscribe.success_title": "Unsubscribed",
  "newsletter_unsubscribe.success_message": "You will no longer receive our emails. See you soon on Suji!",
  "newsletter_unsubscribe.not_found_title": "Address not found",
  "newsletter_unsubscribe.not_found_message": "This address is not subscribed to the newsletter — nothing to unsubscribe.",
  "newsletter_unsubscribe.error_title": "Something went wrong",
  "newsletter_unsubscribe.error_message": "Unsubscription failed. Please try again in a moment.",
  "newsletter_unsubscribe.invalid_email": "Invalid email address",

  // Payment result (pages /payment/success and /payment/failed)
  "payment.checking_title": "Verifying payment...",
  "payment.checking_desc": "We are confirming your payment with our provider. This only takes a few seconds.",
  "payment.success_title": "Payment confirmed!",
  "payment.success_xpress": "Your purchase request is now Xpress: priority processing within 48-72h.",
  "payment.success_subscription": "Your subscription is active. Enjoy your boosted visibility!",
  "payment.success_featured": "Your Showcase is active: your profile is highlighted for 30 days.",
  "payment.success_generic": "Your payment has been confirmed successfully.",
  "payment.xpress_success_title": "Request posted successfully!",
  "payment.xpress_success_message": "Your request has been registered and will be processed as a priority: you will receive supplier proposals within 72 business hours.",
  "payment.xpress_success_steps": "Next steps:",
  "payment.xpress_success_step1": "You will receive supplier proposals by email and WhatsApp within 72 business hours.",
  "payment.xpress_success_step2": "Our SUJI team will guide you in comparing the offers and choosing the best supplier.",
  "payment.xpress_cancelled_title": "Payment cancelled",
  "payment.xpress_cancelled_message": "Your request has still been registered in Normal mode (processing within 1 to 2 weeks). You can retry Xpress for this same request to get priority processing within 72 business hours.",
  "payment.xpress_retry": "Retry Xpress — 15,000 FCFA",
  "payment.xpress_retrying": "Redirecting to payment...",
  "payment.back_to_form": "Back to the form",
  "payment.pending_title": "Payment is being processed",
  "payment.pending_desc": "Your payment is not confirmed yet. If you just completed it, this can take a few moments.",
  "payment.pending_refresh": "Check again now",
  "payment.failed_title": "Payment not completed",
  "payment.failed_desc": "The payment could not be confirmed. If you were debited, contact our support — no amount is charged on a failed payment.",
  "payment.missing_id": "No payment reference provided. Please check the link you were redirected from.",
  "payment.back_home": "Back to home",
  "payment.view_requests": "View my requests",
  "payment.view_dashboard": "Go to dashboard",

  // Payment modal (dashboard)
  "payment.modal_title": "Secure payment via Moneroo",
  "payment.modal_desc": "You will be redirected to Moneroo to complete the payment.",
  "payment.modal_starting": "Redirecting...",
  "payment.modal_error": "Could not initialize the payment. Please try again.",
  "payment.modal_cancel": "Cancel",

  // File upload component
  "file_upload.uploading": "Uploading...",
  "file_upload.uploaded": "File uploaded",
  "file_upload.remove": "Remove",
  "file_upload.click_or_drag": "Click to upload or drag and drop",
  "file_upload.hint": "Video (max {{video}} MB), image or PDF/Word document (max {{doc}} MB)",
  "file_upload.failed": "Upload failed"
};

export default common;
